import React from "react";
import "../../components/template/posReceipt/posReceiptTemplateStyle.css";

const SAMPLE_DATA = {
  nameOfStore: "STYKA RESTAURANT",
  contactNumber: "9876543210",
  address: "MG Road, Kochi, Kerala",
  trnNumber: "32AFVFS2518D1ZZ",
  email: "info@styka.com",
  name: "BIL/001",
  orderDate: "2026-02-17 12:00:00",
  ordType: "DINE IN",
  cashier: "ADMIN",
  orderInfo: [
    { productName: "Chicken Burger", unitPrice: 189, qty: 1, subTotalWoTax: 189, nativeName: "برجر دجاج", imageUrl: "https://via.placeholder.com/40" },
    { productName: "French Fries", unitPrice: 99, qty: 2, subTotalWoTax: 198, nativeName: "بطاطس مقلية", imageUrl: "https://via.placeholder.com/40" },
  ],
  taxableAmt: 387,
  taxDetails: [
    { taxName: "CGST 2.5% incl.", taxPercentage: 2.5, amount: 9.68 },
    { taxName: "SGST 2.5% incl.", taxPercentage: 2.5, amount: 9.68 },
  ],
  amtTotal: 406.36,
  paymentInfo: [{ type: "cash", amount: 410 }],
  kotInfo: [{ kotNo: "KOT-022" }],
  termsAndConditions: "Thank you for dining with us!",
};

const ReceiptTemplatePreview = ({ templateId, font, logo }) => {
  const d = SAMPLE_DATA;
  const dp = 2;
  const isCompact = templateId === 5;
  const isPremium = templateId === 6;
  const isArabicPremium = templateId === 7;
  const isSpaceSaver = templateId === 8;
  const isFormat4 = templateId === 9;
  const isItemsImage = templateId === 10;
  const isTokenStyle = templateId === 11;
  const hasToken = [2, 4, 6, 7, 11].includes(templateId);
  const isArabic = templateId === 3;

  const fontFamily = `'${font}', sans-serif`;
  const baseFontSize = isCompact ? "5px" : isTokenStyle ? "7px" : "6px";
  const headerFontSize = isCompact ? "7px" : (isPremium || isArabicPremium) ? "9px" : isTokenStyle ? "8px" : "8px";

  const containerStyle = {
    fontFamily,
    fontSize: baseFontSize,
    lineHeight: "1.3",
    padding: "4px 5px",
    backgroundColor: "#fff",
    width: "100%",
    boxSizing: "border-box",
    direction: isArabicPremium ? "rtl" : "ltr",
  };

  const hr = <hr style={{ border: "none", borderTop: "1px dashed #999", margin: "2px 0" }} />;
  const dotHr = <hr style={{ border: "none", borderTop: "1px dotted #999", margin: "2px 0" }} />;

  const totalPaid = d.paymentInfo.reduce((s, p) => s + p.amount, 0);
  const change = totalPaid - d.amtTotal;

  return (
    <div style={containerStyle}>
      {/* HEADER */}
      <div style={{ textAlign: "center", marginBottom: "2px" }}>
        {logo && (
          <div style={{ marginBottom: "3px" }}>
            <img src={logo} alt="logo" style={{ maxHeight: isCompact ? "16px" : "24px", objectFit: "contain" }} onError={(e) => { if (e?.target?.style) e.target.style.display = "none"; }} />
          </div>
        )}
        {isTokenStyle ? (
          <>
            <div style={{ fontSize: headerFontSize, fontWeight: "700" }}>{d.nameOfStore}</div>
            <div style={{ fontSize: baseFontSize, fontWeight: "700", textTransform: "uppercase" }}>{d.address}</div>
            <div style={{ fontSize: baseFontSize }}>Contact No: {d.contactNumber}</div>
            {d.trnNumber && <div style={{ fontSize: baseFontSize }}>GST No.: {d.trnNumber}</div>}
          </>
        ) : (isSpaceSaver || isFormat4 || isItemsImage || isCompact) ? (
          <>
            <div style={{ fontSize: headerFontSize, fontWeight: "700" }}>{d.nameOfStore}</div>
            <div style={{ fontSize: baseFontSize }}>Ph: {d.contactNumber}</div>
            <div style={{ fontSize: baseFontSize }}>{d.address}</div>
          </>
        ) : isArabicPremium ? (
          <>
            <div style={{ fontSize: "9px", fontWeight: "700", direction: "rtl" }}>{d.nameOfStore}</div>
            <div style={{ fontSize: baseFontSize }}>{d.address}</div>
            <div style={{ fontSize: baseFontSize }}>{d.contactNumber}</div>
            <div style={{ fontSize: baseFontSize }}>TRN: {d.trnNumber}</div>
          </>
        ) : isPremium ? (
          <>
            <div style={{ fontSize: "9px", fontWeight: "700", textTransform: "uppercase" }}>{d.nameOfStore}</div>
            <div style={{ fontSize: baseFontSize, fontStyle: "italic" }}>{d.address}</div>
            <div style={{ fontSize: baseFontSize }}>{d.contactNumber}</div>
            <div style={{ fontSize: baseFontSize }}>TRN: {d.trnNumber}</div>
          </>
        ) : (
          <>
            <div style={{ fontSize: headerFontSize, fontWeight: "700" }}>{d.nameOfStore}</div>
            <div style={{ fontSize: baseFontSize }}>{d.email}</div>
            <div style={{ fontSize: baseFontSize }}>{d.contactNumber}</div>
            {d.trnNumber && <div style={{ fontSize: baseFontSize }}>TRN: {d.trnNumber}</div>}
          </>
        )}
      </div>

      {hr}

      {/* INVOICE DETAILS */}
      <div style={{ fontSize: baseFontSize, marginBottom: "1px" }}>
        {isItemsImage ? (
          <>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>{d.orderDate.split(" ")[0]}</span>
              <span>Bill No:{d.name}</span>
            </div>
            <div>Customer: Walk-in</div>
            <div>Phone: 9876543210</div>
            <div>Cashier:{d.cashier}</div>
            <div style={{ fontWeight: "800" }}>KOT: KOT001</div>
          </>
        ) : isTokenStyle ? (
          <>
            <div style={{ textAlign: "center" }}>{d.orderDate.split(" ")[0]} {d.orderDate.split(" ")[1].substring(0,5)}</div>
            <div style={{ textAlign: "center", fontWeight: "700" }}>Dine In</div>
            {/* Token Number - on one line bold */}
            <div style={{ margin: '4px 0', textAlign: 'center' }}>
              <span style={{ fontSize: '5px', fontWeight: '600' }}>Your Token No.: 33</span>
            </div>
            <hr style={{ border: "none", borderTop: "1px dashed #999", margin: "2px 0" }} />
            {/* Quick Bill & User */}
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '5px' }}>
              <span style={{ fontWeight: '700' }}>Quick Bill</span>
              <span>User : {d.cashier}</span>
            </div>
            <div style={{ textAlign: 'left', fontSize: '5px' }}>Pay Mode: Cash</div>
          </>
        ) : (isSpaceSaver || isFormat4) ? (
          <>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>{d.orderDate.split(" ")[0]}</span>
              <span>Bill No:{d.name}</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>GST:{d.trnNumber}</span>
              <span>Cashier:{d.cashier}</span>
            </div>
          </>
        ) : (
          <>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>Invoice: {d.name}</span>
              <span>{d.ordType}</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>{d.orderDate.split(" ")[0]}</span>
              <span>Cashier: {d.cashier}</span>
            </div>
          </>
        )}
      </div>

      {hr}

      {/* TABLE */}
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: baseFontSize }}>
        <thead>
          <tr style={{ borderBottom: "1px solid #999" }}>
            {(isSpaceSaver || isFormat4 || isItemsImage || isTokenStyle) ? (
              <>
                <th style={{ textAlign: "left", fontWeight: "700", width: isTokenStyle ? "40%" : "35%" }}>{isTokenStyle ? "Item" : "ITEM"}</th>
                <th style={{ textAlign: "right", fontWeight: "700", width: isTokenStyle ? "15%" : "25%" }}>{isTokenStyle ? "Qty" : "BASE PRICE"}</th>
                <th style={{ textAlign: "center", fontWeight: "700", width: isTokenStyle ? "20%" : "15%" }}>{isTokenStyle ? "Rate" : "QTY"}</th>
                <th style={{ textAlign: isTokenStyle ? "center" : "right", fontWeight: "700", width: "25%" }}>{isTokenStyle ? "Total" : "T.VALUE"}</th>
              </>
            ) : (
              <>
                <th style={{ textAlign: "left", fontWeight: "700", width: "40%" }}>Item</th>
                <th style={{ textAlign: "right", fontWeight: "700", width: "15%" }}>Qty</th>
                <th style={{ textAlign: "center", fontWeight: "700", width: "20%" }}>Price</th>
                <th style={{ textAlign: "right", fontWeight: "700", width: "25%" }}>Amount</th>
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {d.orderInfo.map((item, i) => (
            isTokenStyle ? (
              <React.Fragment key={i}>
                <tr>
                  <td style={{ textAlign: "left", fontWeight: "600" }}>{item.productName}</td>
                  <td style={{ textAlign: "right" }}>{item.qty}</td>
                  <td style={{ textAlign: "center" }}>{item.unitPrice.toFixed(dp)}</td>
                  <td style={{ textAlign: "right" }}>{item.subTotalWoTax.toFixed(dp)}</td>
                </tr>
                <tr>
                  <td colSpan={4} style={{ textAlign: "left", fontSize: "5px", color: "#555", paddingBottom: "2px" }}>
                    {item.qty} x PCS
                  </td>
                </tr>
              </React.Fragment>
            ) : isItemsImage ? (
              <React.Fragment key={i}>
                <tr>
                  <td colSpan={4} style={{ padding: "2px 0 0 0" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "3px" }}>
                      <div style={{ width: "16px", height: "16px", borderRadius: "2px", border: "1px solid #ddd", backgroundColor: "#f0f0f0", flexShrink: 0 }} />
                      <span style={{ fontSize: "5px", fontWeight: "600" }}>{item.productName}</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left", fontSize: "5px", color: "#555" }}>{item.productName}</td>
                  <td style={{ textAlign: "right" }}>{item.unitPrice.toFixed(dp)}</td>
                  <td style={{ textAlign: "center" }}>{item.qty}</td>
                  <td style={{ textAlign: "right" }}>{item.subTotalWoTax.toFixed(dp)}</td>
                </tr>
              </React.Fragment>
            ) :
            <tr key={i}>
              <td style={{ textAlign: "left" }}>
                {item.productName}
                {isArabic && <div style={{ fontSize: "5px" }}>{item.nativeName}</div>}
              </td>
              {(isSpaceSaver || isFormat4) ? (
                <>
                  <td style={{ textAlign: "right" }}>{item.unitPrice.toFixed(dp)}</td>
                  <td style={{ textAlign: "center" }}>{item.qty}</td>
                </>
              ) : (
                <>
                  <td style={{ textAlign: "right" }}>{item.qty.toFixed(dp)}</td>
                  <td style={{ textAlign: "center" }}>{item.unitPrice.toFixed(dp)}</td>
                </>
              )}
              <td style={{ textAlign: "right" }}>{item.subTotalWoTax.toFixed(dp)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          {isTokenStyle ? (
            <>
              <tr>
                <td style={{ textAlign: "left", fontWeight: "700" }}>Total :</td>
                <td style={{ textAlign: "right", fontWeight: "700" }}>{d.orderInfo.reduce((s, it) => s + it.qty, 0)}</td>
                <td></td>
                <td style={{ textAlign: "right", fontWeight: "700" }}>Rs {d.taxableAmt.toFixed(dp)}</td>
              </tr>
              {d.taxDetails.map((t, i) => (
                <tr key={i}>
                  <td colSpan={3} style={{ textAlign: "right" }}>{t.taxName}:</td>
                  <td style={{ textAlign: "right" }}>Rs{t.amount.toFixed(dp)}</td>
                </tr>
              ))}
              <tr>
                <td colSpan={2} style={{ textAlign: "left", fontWeight: "700", fontSize: "6.5px" }}>Grand Total :</td>
                <td colSpan={2} style={{ textAlign: "right", fontWeight: "700", fontSize: "6.5px" }}>Rs {d.amtTotal.toFixed(dp)}</td>
              </tr>
            </>
          ) : (
            <>
              <tr>
                <td colSpan={3} style={{ textAlign: "right", fontWeight: "700" }}>
                  {(isFormat4 || isItemsImage) ? "Cart Total:" : "Sub Total:"}
                </td>
                <td style={{ textAlign: "right", fontWeight: "700" }}>{d.taxableAmt.toFixed(dp)}</td>
              </tr>
              {d.taxDetails.map((t, i) => (
                <tr key={i}>
                  <td colSpan={3} style={{ textAlign: "right" }}>{t.taxName}:</td>
                  <td style={{ textAlign: "right" }}>{t.amount.toFixed(dp)}</td>
                </tr>
              ))}
              <tr>
                <td colSpan={3} style={{ textAlign: "right", fontWeight: "700", fontSize: isCompact ? "6px" : "7px" }}>Grand Total:</td>
                <td style={{ textAlign: "right", fontWeight: "700", fontSize: isCompact ? "6px" : "7px" }}>{d.amtTotal.toFixed(dp)}</td>
              </tr>
            </>
          )}
        </tfoot>
      </table>

      {hr}

      {/* PAYMENT DETAILS - Format 4/10 */}
      {(isFormat4 || isItemsImage) && (
        <>
          <table style={{ width: "100%", fontSize: baseFontSize }}>
            <tbody>
              <tr>
                <td style={{ fontWeight: "700" }}>Tender:</td>
                <td style={{ textAlign: "right", fontWeight: "700" }}>{totalPaid.toFixed(dp)}</td>
              </tr>
              {change > 0 && (
                <tr>
                  <td style={{ fontWeight: "700" }}>Change:</td>
                  <td style={{ textAlign: "right", fontWeight: "700" }}>{change.toFixed(dp)}</td>
                </tr>
              )}
              <tr>
                <td style={{ fontWeight: "700" }}>Payment Mode:</td>
                <td style={{ textAlign: "right", fontWeight: "700" }}>Cash</td>
              </tr>
            </tbody>
          </table>
          {hr}
        </>
      )}

      {/* PAYMENT DETAILS - Token Style */}
      {isTokenStyle && (
        <>
          <hr style={{ border: "none", borderTop: "1px dashed #999", margin: "2px 0" }} />
          <div style={{ fontSize: baseFontSize }}>Customer: Walk-in (9876543210)</div>
          <hr style={{ border: "none", borderTop: "1px dashed #999", margin: "2px 0" }} />
          <div style={{ fontSize: baseFontSize, fontWeight: "700" }}>Paid Amount: Rs {totalPaid.toFixed(dp)}</div>
          {change > 0 && <div style={{ fontSize: baseFontSize, fontWeight: "700" }}>Return Amount: Rs {change.toFixed(dp)}</div>}
          {hr}
        </>
      )}

      {/* TOKEN - Token Style already shows token in invoice details, skip here */}
      {hasToken && !isTokenStyle && (
        <div style={{ textAlign: "center", margin: "2px 0" }}>
          <span style={{
            display: "inline-block",
            background: "#000",
            color: "#fff",
            padding: "1px 6px",
            borderRadius: "2px",
            fontSize: "7px",
            fontWeight: "700"
          }}>
            {isArabicPremium ? "رقم الطلب: KOT-022" : "KOT No: KOT001"}
          </span>
        </div>
      )}

      {/* T&C */}
      {d.termsAndConditions && (
        <div style={{ fontSize: "5px", textAlign: "center", padding: "2px 0" }}>
          {d.termsAndConditions}
        </div>
      )}

      {dotHr}

      {/* FOOTER */}
      <div style={{ textAlign: "center", fontWeight: "700", fontSize: baseFontSize, padding: "1px 0" }}>
        {isArabicPremium ? "شكرًا لزيارتكم" : "THANK YOU"}
        {isArabic && <div>شكرًا لك</div>}
      </div>

      {hr}
    </div>
  );
};

export default ReceiptTemplatePreview;
